import React, { Fragment } from 'react';
import { translate } from '../../Services/translation';

const sameCategory = (item, index, array) => index > 0 && array[index - 1].category === array[index].category || item.showAll;

const trackKlevu = (id) => {
    sessionStorage.setItem('klevu', '/api/klevu/quicksearch?v=' + id + "&q=" + 
        encodeURIComponent(document.querySelector('.quick-search__input').value));
}

const QuickSearchResult = ({ result, selectedItem, searchUrl }) => (
    <div className="quick-search-result">
        <ul className="quick-search-result__container">
            {result && result.map((item, index, array) => (
                <Fragment key={`${item.name}-${index}`}>
                    {item.category === 'NoHit' || sameCategory(item, index, array) ? null :
                        <li className="quick-search-result__item quick-search-result__group-header" >{item.category}</li>
                    }
                    <li className={`quick-search-result__item ${selectedItem === index ? 'quick-search-result__item--selected' : ''}`}> 
                        <a onClick={() => trackKlevu(item.id)} className={item.showAll ? 'quick-search-result__show-all' : `quick-search-result__link ${item.url ? '' : 'quick-search-result__link--disabled'}`}
                            href={item.showAll ? searchUrl : item.url}>
                            {item.hasImage && item.imageSource && <img className="quick-search-result__image" src={item.imageSource} />}
                            {item.category == translate('quicksearchheader.suggestions')? <div dangerouslySetInnerHTML={{__html: item.name}}></div> : <div>{item.name}</div> }
                        </a>
                    </li>
                </Fragment>
            ))}
        </ul>
    </div>
)

export default QuickSearchResult;